import AuthService from "./auth.service";
import http from "./http-common";

const token = AuthService.getToken();

const getTodaysAttendenceLogs = () => {
  return http.get("/AttendanceLog/GetTodaysAttendenceLogs", {
    headers: { Authorization: "Bearer " + token },
  });
};

const getAllEmpMonthlyAttendenceLogs = (data) => {
  return http.post("/AttendanceLog/GetAllEmpMonthlyAttendenceLogs", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getEmpMonthlyAttendenceLogs = (data) => {
  return http.post("/AttendanceLog/GetEmpMonthlyAttendenceLogs", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const LogsService = {
  getTodaysAttendenceLogs,
  getAllEmpMonthlyAttendenceLogs,
  getEmpMonthlyAttendenceLogs,
};

export default LogsService;
